import React, { useState, useEffect } from 'react';
import anchorme from 'anchorme';
import PropTypes from 'prop-types';
import { formatDate } from '../../helpers/index';
import '../../context/global';
import api from '../../context/api';
import mint from '../../helpers/hashcash';

import './message.scss';
import AttachmentIcon from './Attachments/AttachmentIcon';
import ListingContainer from './Listing/Listing.container';

const Message = ({ ...props }) => {
  const [showTranslate, setShowTranslate] = useState(false);
  const [translatedMessage, setTranslatedMessage] = useState('');
  const [question, setQuestion] = useState({
    showQuestion: true,
    userAnswer: false,
  });
  const {
    langToTranslate,
    message,
    showTranslatePopup,
    isAdmin,
    isBot,
    isMine,
    firstInGroup,
    theDate,
    readReceipt,
    showDate,
    totalMember,
    chatListingData,
    activeRoom,
    autoResponded,
    userId,
    userToken,
    trans,
    chatRateToggle,
  } = props;

  const { showQuestion, userAnswer } = question;

  let rightClass = 'received';
  let firstGroupClass = '';

  const doTranslate = () => {
    api
      .post('translate-message/', {
        message: message.message,
        target_language: langToTranslate,
      })
      .then(response => {
        setShowTranslate(true);
        setTranslatedMessage(response.data.translatedText);
      });
  };

  useEffect(() => {
    if (langToTranslate !== null) {
      doTranslate();
    }
  }, langToTranslate);

  const doShowTranslate = () => {
    let theMessage = message.message;
    if (theMessage.length > 25) {
      theMessage = `${theMessage.substring(0, 25)} ...`;
    }
    showTranslatePopup(message.messageId, theMessage);
  };

  const sendInquiry = theAnswer => {
    console.log(chatListingData);
    let other_location = '';
    if (chatListingData.address_line_2 !== '') {
      other_location = `${chatListingData.address_line_2}, ${chatListingData.address_locality}`;
    }

    let hashcashtoken;
    mint('enquiry')
      .then(token => {
        hashcashtoken = token;
        const opportunityData = {
          contact_name: 'default',
          from_email: '',
          contact_number: '',
          message: '',
          listing_id: chatListingData.id,
          buy_rent: 'buy',
          other_location,
          location: chatListingData.address_subdivision,
          property_type: chatListingData.category_name,
          token: hashcashtoken,
          user_id: userId,
        };
        api
          .post('enquiries/opportunity/', opportunityData, {
            headers: {
              'x-sendbird-id': userId,
              'x-sendbird-token': userToken,
            },
          })
          .then(() => {
            const postData = {
              room_code: JSON.parse(activeRoom.data).chatroom_id,
              the_answer: theAnswer,
            };
            api
              .post('chat/reply-auto-respond/', postData, {
                headers: {
                  'x-sendbird-id': userId,
                  'x-sendbird-token': userToken,
                },
              })
              .then(() => {
                setQuestion({
                  showQuestion: false,
                  userAnswer: theAnswer,
                });

                chatRateToggle();
              });
          });
      })
      .catch(error => {
        console.log(error);
      });
  };

  let botMessageReplace = '';
  let theMessage = '';
  if (isMine) {
    rightClass = 'sent';
  }
  if (isAdmin) {
    rightClass = 'received admin';
  }
  if (isBot) {
    rightClass = 'received bot first';
  }
  if (firstInGroup) {
    firstGroupClass = 'first';
  }

  const messageTime = formatDate(message.createdAt);

  let avatarPhoto = `${process.env.REACT_APP_PORTAL_URL}/static/img/smiley-red.svg`;
  if (!isAdmin && !isBot) {
    if (message._sender.profileUrl !== '') {
      avatarPhoto = message._sender.profileUrl;
    }
  } else if (isBot) {
    avatarPhoto = `${process.env.REACT_APP_PORTAL_URL}/static/img/logo-icon.svg`;
  }
  const messageSenderStyle = {
    backgroundImage: `url(${avatarPhoto})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  let messageTextTranslatedStyle = {};
  if (!showTranslate) {
    messageTextTranslatedStyle = {
      display: 'none',
    };
  } else {
    messageTextTranslatedStyle = {
      display: 'unset',
    };
  }
  const messageDateWrapper = showDate ? (
    <div className="message-date-divider">
      <span>{theDate}</span>
    </div>
  ) : null;

  const readIcon = readReceipt <= 0 ? 'blue-done' : 'grey-done';
  const readIconType = readReceipt === totalMember - 1 ? 'done' : 'done_all';
  if (message.messageType === 'file') {
    if (message.type.includes('image')) {
      theMessage = `<a href="${message.url}" target="_blank"><img src="${message.url}"></a>`;
    } else {
      // theMessage = <AttachmentIcon attachment={message} activeRoom={activeRoom} />;
      // theMessage = `<span class="attached-file"><i class="material-icons">attach_file</i> <a href="${message.url}" target="_blank">${message.name}</a></span>`;
    }
  } else {
    theMessage = anchorme(message.message, {
      truncate: [26, 15],
      attributes: [
        {
          name: 'target',
          value: '_blank',
        },
      ],
    });
  }

  if (isBot) {
    const botMessage =
      trans[
        'Dear {name}, we noticed that nobody has responded to your request. Would you like to send your request to agents with similar properties?'
      ] ||
      'Dear {name}, we noticed that nobody has responded to your request. Would you like to send your request to agents with similar properties?';
    botMessageReplace = botMessage.replace('{name}', message.data);
    theMessage = botMessageReplace;
  }
  return (
    <>
      {messageDateWrapper}
      <div className={`message-wrapper ${rightClass} ${firstGroupClass}`} id={message.messageId}>
        {firstInGroup ? <div className="message-sender" style={messageSenderStyle} /> : null}
        <div className={`message-text-wrapper ${message.messageType}`}>
          {rightClass === 'sent' && (
            <i
              className={`material-icons ${readIcon}`}
              style={{ fontSize: '12px', marginRight: '5px' }}
            >
              {readIconType}
            </i>
          )}
          <div className="message-text">
            {rightClass === 'received' && firstInGroup && (
              <div className="message-sender-name">{!isAdmin && message._sender.nickname}</div>
            )}
            {message.customType === 'listing' && <ListingContainer message={message.message} />}
            {message.messageType === 'file' && (
              <AttachmentIcon sender={rightClass} attachment={message} />
            )}
            {message.messageType !== 'file' && message.customType !== 'listing' && (
              <span dangerouslySetInnerHTML={{ __html: theMessage }} />
            )}
            {isBot && !autoResponded.respond_replied && showQuestion ? (
              <>
                <button
                  type="button"
                  className="respond-button yes"
                  onClick={() => sendInquiry(true)}
                >
                  {trans['Yes - Send my inquiry to other agents']}
                </button>
                <button
                  type="button"
                  className="respond-button no"
                  onClick={() => sendInquiry(false)}
                >
                  {trans['No - I prefer to wait for this agent to respond']}
                </button>
              </>
            ) : null}
            {isBot && autoResponded.respond_replied && autoResponded.respond_answer ? (
              <span>
                <br />
                {trans['Done! Your request is on its way. Up to 5 agents will contact you soon!']}
                <br />
                {
                  trans[
                    'Please rate your experience with this agent so that we can improve customer service'
                  ]
                }
              </span>
            ) : null}
            {isBot && autoResponded.respond_replied && !autoResponded.respond_answer ? (
              <span>
                <br />
                {
                  trans[
                    'Thanks for using Realestate.com.kh. Please rate your experience with this agent so that we can improve customer service'
                  ]
                }
              </span>
            ) : null}
            {isBot && !showQuestion && userAnswer ? (
              <span>
                <br />
                {trans['Done! Your request is on its way. Up to 5 agents will contact you soon!']}
                <br />
                {
                  trans[
                    'Please rate your experience with this agent so that we can improve customer service'
                  ]
                }
              </span>
            ) : null}
            {isBot && !showQuestion && !userAnswer ? (
              <span>
                <br />
                {trans['Thanks for using Realestate.com.kh.']}
              </span>
            ) : null}
            {rightClass === 'received' && (
              <div className="message-text-translated" style={messageTextTranslatedStyle}>
                <hr />
                {translatedMessage}
              </div>
            )}
            <div className="message-time">{!isAdmin && messageTime}</div>
          </div>
          {rightClass === 'received' &&
            message.messageType !== 'file' &&
            message.customType !== 'listing' && (
              <button type="button" className="message-translate" onClick={doShowTranslate}>
                <i className="material-icons">translate</i>
              </button>
            )}
        </div>
      </div>
    </>
  );
};

Message.defaultProps = {
  langToTranslate: null,
};

Message.propTypes = {
  message: PropTypes.shape().isRequired,
  showTranslatePopup: PropTypes.func.isRequired,
  isMine: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isBot: PropTypes.bool.isRequired,
  firstInGroup: PropTypes.bool.isRequired,
  showDate: PropTypes.bool.isRequired,
  theDate: PropTypes.string.isRequired,
  readReceipt: PropTypes.number.isRequired,
  langToTranslate: PropTypes.string,
  totalMember: PropTypes.number.isRequired,
  chatListingData: PropTypes.string.isRequired,
  activeRoom: PropTypes.shape().isRequired,
  trans: PropTypes.shape().isRequired,
  userId: PropTypes.string.isRequired,
  userToken: PropTypes.string.isRequired,
  autoResponded: PropTypes.bool.isRequired,
  chatRateToggle: PropTypes.shape().isRequired,
};

export default Message;
